import PropTypes from 'prop-types';
import styled from 'styled-components';
import { isMobileOnly } from 'react-device-detect';

const DragDropArea = styled.div`
  position: absolute;
  z-index: 1;
  background: transparent;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  pointer-events: ${({ $pointerEventsNone }) =>
    $pointerEventsNone ? 'none' : 'auto'};
`;

const Dropzone = ({ getInputProps, pointerEventsNone }) => {
  const inputProps = getInputProps();
  return (
    <DragDropArea $pointerEventsNone={pointerEventsNone}>
      <input
        {...inputProps}
        style={
          isMobileOnly
            ? {
                opacity: 0,
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                cursor: 'pointer',
              }
            : { display: 'none' }
        }
        onClick={(e) => {
          if (inputProps.onClick) inputProps.onClick(e);
          e.target.value = null;
        }}
      />
    </DragDropArea>
  );
};

Dropzone.propTypes = {
  getInputProps: PropTypes.func.isRequired,
  pointerEventsNone: PropTypes.bool,
};

export default Dropzone;
